import React, {useEffect, useState} from 'react';
import { useDispatch } from 'react-redux';

import {addGameClaimVariables} from "_features/entries/entry-slice";
import {ResultActionButtons} from "_components/ActionButtons/ResultActionButtons";
import {ResultCopy} from "_components/ResultCopy/ResultCopy";

import {
    empty,
    logIt
} from "__globals/global-functions";

import * as GC from '__globals/GLOBAL-CONSTANTS.js';


export const LoseStandard = props => {

    logIt( GC.RESULT_LOSE + " RESULT IS CALLED", null, false );

    const RESULT_KEY = GC.RESULT_LOSE; // for the title and copy

    const dispatch = useDispatch();

    /** Retrieve the game claim variables */
    useEffect(() => {
        if ( !empty(props.gameClaim) && !empty(props.promotion) ) {
            dispatch( addGameClaimVariables(props.gameClaim) );
        }
    }, [props.gameClaim, props.promotion]);

    // RETURN THE GAME RESULT
    return (

        <div id='lose_standard' >

            <ResultCopy
                jsonKey={RESULT_KEY}
                entry={props.entry}
                promotion={props.promotion}
                gameClaim={props.gameClaim}
            />

            <ResultActionButtons
                promotion={props.promotion}
                gameClaim={props.gameClaim}
                jsonKey={RESULT_KEY}
                doAction={props.doAction}
            />

        </div>

    );
}


export default LoseStandard;